import { render, staticRenderFns } from "./pie3dType3.vue?vue&type=template&id=e6fa11e8&scoped=true&"
import script from "./pie3dType3.vue?vue&type=script&lang=js&"
export * from "./pie3dType3.vue?vue&type=script&lang=js&"
import style0 from "./pie3dType3.vue?vue&type=style&index=0&id=e6fa11e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6fa11e8",
  null
  
)

export default component.exports